module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isSplash()) ? _c('header', {
    staticClass: "adv-header mdl-layout__header mdl-color--blue-grey-900 mdl-color-text--white"
  }, [_c('div', {
    staticClass: "mdl-layout__header-row adv-titlebar"
  }, [_c('h4', {
    staticClass: "adv-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo-adventify",
    attrs: {
      "src": "images/logo.png"
    }
  }), _vm._v(" ADVENTIFY \n        "), (_vm.isCreateMode()) ? _c('span', {
    staticStyle: {
      "position": "relative",
      "left": "5px",
      "top": "-3px",
      "padding": "1px 3px",
      "color": "#263238",
      "background-color": "#ffffff",
      "border-radius": "3px",
      "font-size": "12px"
    }
  }, [_vm._v("\n          EDITOR")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "top": "-55px",
      "left": "144px",
      "height": "0px",
      "width": "0px",
      "margin": "0",
      "padding": "0",
      "font-size": "10px",
      "text-orientation": "sideways",
      "color": "#FF5722",
      "pointer-events": "none"
    }
  }, [_vm._v("BETA")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "mdl-layout-spacer"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('button', {
    staticClass: "adv-sign-in-button mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "hidden": _vm.user
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]), _vm._v(" Sign in")])]), _vm._v(" "), _c('div', {
    staticClass: "adv-signed-in-user-container mdl-cell--hide-phone ",
    attrs: {
      "hidden": !_vm.user
    }
  }, [_c('a', {
    staticClass: "adv-usernamelink mdl-button mdl-js-button"
  }, [_c('div', {
    staticClass: "adv-avatar",
    style: (_vm.getUserAvatar())
  }), _vm._v(" "), _c('div', {
    staticClass: "adv-username mdl-color-text--white"
  }, [_vm._v(_vm._s(_vm.user && (_vm.user.displayName || _vm.user.email)))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "adv-menu-list mdl-menu mdl-js-menu mdl-js-ripple-effect mdl-menu--bottom-right",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "for": "adv-menu"
    }
  }, [_vm._m(2), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("gamepad")]), _vm._v(" Adventures")])]), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/recent"
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("history")]), _vm._v(" Recently Played")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticStyle: {
      "pointer-events": "none",
      "opacity": "0.33"
    },
    attrs: {
      "disabled": "",
      "to": "/genres"
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item",
    attrs: {
      "disabled": ""
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_module")]), _vm._v(" Genres")])]), _vm._v(" "), (_vm.user) ? _c('li', [_c('div', {
    staticClass: "nav-separator-title"
  }, [_vm._v("Create")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/editor"
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("create")]), _vm._v(" Adventure Editor")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/documentation"
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("local_library")]), _vm._v(" Documentation")])]) : _vm._e(), _vm._v(" "), _vm._m(3), _vm._v(" "), (!_vm.user) ? _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_c('li', {
    staticClass: "mdl-menu__item"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("account_circle")]), _vm._v(" Sign In")])]) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('li', {
    staticClass: "adv-sign-out mdl-menu__item",
    on: {
      "click": _vm.logOut
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("exit_to_app")]), _vm._v(" Sign out")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "adv-tab mdl-layout__header-row mdl-cell--hide-phone mdl-color--deep-orange"
  }, [_c('div', {
    staticClass: "mdl-tab"
  }, [(!_vm.isCreateMode()) ? _c('router-link', {
    staticClass: "adv-player-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/",
      "id": "adv-menu-home"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("gamepad")]), _vm._v(" Adventures")]) : _vm._e(), _vm._v(" "), (_vm.user && !_vm.isCreateMode()) ? _c('router-link', {
    staticClass: "adv-player-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/recent",
      "id": "adv-menu-recent"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("history")]), _vm._v(" Recently Played")]) : _vm._e(), _vm._v(" "), (!_vm.isCreateMode()) ? _c('router-link', {
    staticClass: "adv-player-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect",
    staticStyle: {
      "pointer-events": "none"
    },
    attrs: {
      "disabled": "",
      "to": "/genres",
      "id": "adv-menu-genres"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("view_module")]), _vm._v(" Genres")]) : _vm._e(), _vm._v(" "), (_vm.isCreateMode()) ? _c('router-link', {
    staticClass: "adv-create-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/editor",
      "id": "adv-menu-editor"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("create")]), _vm._v(" My Adventures")]) : _vm._e(), _vm._v(" "), (_vm.isCreateMode()) ? _c('router-link', {
    staticClass: "adv-create-menu mdl-layout__tab mdl-button mdl-js-button mdl-js-ripple-effect",
    attrs: {
      "to": "/documentation",
      "id": "adv-menu-documentation"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("local_library")]), _vm._v(" Documentation")]) : _vm._e()], 1)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "adv-searchcontainer mdl-textfield mdl-js-textfield mdl-textfield--expandable"
  }, [_c('label', {
    staticClass: "mdl-button mdl-js-button mdl-button--icon",
    attrs: {
      "for": "searchQuery"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("search")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-textfield__expandable-holder"
  }, [_c('input', {
    staticClass: "mdl-textfield__input",
    attrs: {
      "type": "text",
      "id": "searchQuery"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mdl-textfield__label",
    attrs: {
      "for": "searchQuery"
    }
  }, [_vm._v("Enter your query...")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "adv-searchResults"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mdl-button mdl-js-button mdl-js-ripple-effect mdl-button--icon mdl-cell--hide-phone",
    attrs: {
      "id": "adv-menu"
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("more_vert")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "nav-separator-title"
  }, [_vm._v("Play")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    staticClass: "nav-separator-title"
  }, [_vm._v("Account")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-64b7e904!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionHeader.vue
// module id = 314
// module chunks = 0